import styled, { css, createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .dimmer {
    z-index: 9999 !important
  }

  .ui.modal.ui.modal.ui.modal {
    top: initial !important;
    overflow: auto !important;
    max-height: 70vh;
  }
`

export const InputWrapper = styled(({ disabled, ...rest }) => (
  <div {...rest} />
))<{
  disabled?: boolean
}>`
  ${({ disabled, theme }) => css`
    cursor: pointer;

    .ui.disabled.dropdown {
      background: ${disabled
        ? theme.colors.backgroundColor
        : '#fff'} !important;
    }
  `}
`

export const Search = styled.input`
  width: 100%;
  background: #ffffff;
  padding: 1em;
  border: 1px solid #e6e8eb;
  box-shadow: 0px 2px 12px -5px rgba(0, 46, 62, 0.1);
  border-radius: 4px;
  margin-bottom: 0.5em;
`

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1em 0;
  cursor: pointer;
`
